import { CardContent, FormLabel, Input, Switch, Typography } from "@mui/joy";
import React, { useEffect, useState } from "react";

const TimeInput = ({
    isManualChange,
    setIsManualChange,
    currentTime,
    currentShowTime,
}: {
    isManualChange: boolean;
    setIsManualChange: (value: boolean) => void;
    currentTime?: string;
    currentShowTime?: boolean;
}) => {
    // Fix: Preserve the exact time string from the input without timezone conversion
    const formatTimeString = (timeString?: string) => {
        if (!timeString) return new Date().toLocaleString("sv-SE").replace(" ", "T");

        // If it's already in ISO format, just return it
        if (timeString.includes("T")) return timeString;

        // Handle ISO date string (YYYY-MM-DD) but missing the T separator
        if (timeString.match(/^\d{4}-\d{2}-\d{2}$/)) {
            return `${timeString}T00:00:00`;
        }

        // Handle non-standard date format by constructing it in a timezone-safe way
        const date = new Date(timeString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        const seconds = String(date.getSeconds()).padStart(2, "0");

        return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
    };

    const [time, setTime] = useState<string>(formatTimeString(currentTime));
    const [showTime, setShowTime] = useState<boolean>(currentShowTime ?? true);

    useEffect(() => {
        const intervalId = setInterval(() => {
            if (!isManualChange) {
                setTime(new Date().toLocaleString("sv-SE").replace(" ", "T"));
            }
        }, 1000);

        return () => clearInterval(intervalId);
    }, [isManualChange]);

    // Update time when currentTime prop changes
    useEffect(() => {
        if (currentTime) {
            setTime(formatTimeString(currentTime));
        }
    }, [currentTime]);

    return (
        <CardContent>
            <div>
                <FormLabel sx={{ width: "100%", mb: "6px" }}>
                    Time{" "}
                    {!isManualChange && showTime && (
                        <Typography level="body-xs" color="danger" sx={{ marginLeft: 1 }}>
                            Live •
                        </Typography>
                    )}
                    <Switch
                        checked={showTime}
                        startDecorator={
                            showTime ? (
                                <Typography level="body-xs">Don't Show Time</Typography>
                            ) : (
                                <Typography level="body-xs">Show Time</Typography>
                            )
                        }
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                            setTime(formatTimeString(currentTime));
                            setIsManualChange(false);
                            setShowTime(event.target.checked);
                        }}
                        slotProps={{
                            input: { name: "show_time" },
                            root: { sx: { marginLeft: "auto" } },
                        }}
                    />
                </FormLabel>
                <Input
                    type={showTime ? "datetime-local" : "date"}
                    name="time"
                    value={showTime ? time : time.split("T")[0]}
                    onChange={(e) => {
                        setIsManualChange(true);
                        setTime(e.target.value);
                    }}
                />
            </div>
        </CardContent>
    );
};

export default TimeInput;
